  
   <h2 class="title" mat-dialog-title>   
    Select Color And Icon 
   



    <div class="charColor" [formGroup]="addQuickLinkForm">
      <div class="colGroup">
        <ng-container>
          <ng-container *ngFor="let color of col; let i as index">
            <label class="colm" [ngStyle]="{'background-color': color.colname }">
              <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" name="noteColor"
                formControlName="quickLink">
              <span class="checkmark"></span>
            </label>
          </ng-container>
        </ng-container>

      </div>
      <!-- <label class="nopadding clrlbl"> Characters Remaining: {{maxChars - addnotes}}</label> -->
    </div>


    <button mat-icon-button (click)="closeIcon()">
      <mat-icon>close</mat-icon>
    </button>


  </h2>

  <mat-dialog-content>   
    <div class="search">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput maxlength="20" placeholder="search icon" (input)="searchIcon($event.target.value)">
      </mat-form-field>
    </div>
      <div class="container">
        <div class="item" *ngFor="let template of iconList">        
          <button mat-icon-button (click)="iconSelect(template)" matTooltip="{{template}}">
            <mat-icon>{{template}}</mat-icon>
          </button>
          <!-- <p> {{template}}</p> -->
        </div>
      </div>     

  </mat-dialog-content> 
 
  